import { chapterContentRegWallBoxButtons } from "./articleListedElements";

export const addButtonChapterParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('chapter')) return; // Defined during twig load

  chapterContentRegWallBoxButtons.forEach(btn => {
    const chapter = btn.closest(".article-listed-chapter")?.getAttribute("data-article-listed-chapter");
    if (!chapter) return;
    
    const currentHref = btn.getAttribute("href");
    if (!currentHref) return;
    const newUrl = reorderRedirectUriParams(currentHref, chapter);
    if (!newUrl) return
    btn.setAttribute("href", newUrl);
  });
};

// Helper function to reorder parameters within redirect_uri
const reorderRedirectUriParams = (url: string, chapterValue: string) => {
  // Parse the main URL parameters
  const [mainBaseUrl, mainQueryString, redirectUriQuery] = url.split('?');
  const mainParams = new URLSearchParams(mainQueryString || '');
  
  const redirectUri = mainParams.get('redirect_uri');
  
  if (!redirectUri) return;
  
  // Parse the redirect_uri URL
  const [redirectBaseUrl] = redirectUri.split('?');
  const redirectParams = new URLSearchParams(redirectUriQuery || '');
  
  // Create new URLSearchParams with chapter first
  const newRedirectParams = new URLSearchParams();
  newRedirectParams.set('chapter', chapterValue);
  
  // Add all other existing parameters from redirect_uri (except chapter)
  for (const [key, value] of redirectParams) {
    if (key !== 'chapter') {
      newRedirectParams.set(key, value);
    }
  }
  
  // Reconstruct the redirect_uri with reordered parameters
  const newRedirectUri = redirectBaseUrl + (newRedirectParams.toString() ? '?' + newRedirectParams.toString() : '');
  
  // Update the main URL with the modified redirect_uri
  mainParams.set('redirect_uri', newRedirectUri);
  
  // Reconstruct the full URL
  return mainBaseUrl + '?' + mainParams.toString();
};